import { ERROR_UPDATE_CONFIG, SUCCESS_UPDATE_TEXT, DEFAULT_SLOT_INTERVAL } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { updateOrderSettings, updateShopOrderSettings } from '../../apis/firebase';
import { showNotification } from '../Notification/Notification.view';
export const initDataConfig = async (newProps, component) => {
  const { hours = {}, fleet = {}, autoAccept = {}, nbShops } = newProps;
  const { showOrderInPreparation = false } = fleet;
  const { slotInterval = DEFAULT_SLOT_INTERVAL } = hours;
  const { enabled = false, preparationTime = 0 } = autoAccept;
  const data = nbShops === 1 ? { slotInterval, showOrderInPreparation, enabled, preparationTime } : component.props.isAllShops
    ? { slotInterval, showOrderInPreparation }
    : { enabled, preparationTime };
  component.setState({ data });
};


export const handleChangeSlotInterval = (event, component, isAllShops) => {
  const { data } = component.state;
  const { value } = event.target;
  const newData = { ...data };
  newData[isAllShops ? 'slotInterval' : 'preparationTime'] = value;
  component.setState({
    data: newData
  });
};

export const handleToggle = (event, component, isAllShops) => {
  const { data } = component.state;
  const { checked } = event.target;
  const newData = { ...data };
  newData[isAllShops ? 'showOrderInPreparation' : 'enabled'] = checked;
  component.setState({
    data: newData
  });
};
export const handleSubmitData = async (e, component, isAllShops) => {
  const { openErrorModal, nbShops } = component.props;
  const { data } = component.state;
  const { slotInterval, showOrderInPreparation, preparationTime, enabled } = data;

  try {
    component.setState({ isLoading: true });
    e.preventDefault();
    e.stopPropagation();

    const dataToFirebase = isAllShops
      ? { slotInterval, showOrderInPreparation }
      : { preparationTime, enabled };
    isAllShops ? updateOrderSettings(dataToFirebase) : updateShopOrderSettings(dataToFirebase);
    if (nbShops === 1) {
      updateOrderSettings({ slotInterval, showOrderInPreparation })
    }

    showNotification(
      'light',
      'ltr',
      'primary',
      SUCCESS_UPDATE_TEXT,
      'Les paramètres des commandes ont bien été modifiés.'
    );
  } catch (error) {
    sendCloudWatchAlert(`Error changing order settings ${error}`);
    openErrorModal(ERROR_UPDATE_CONFIG);
  } finally {
    component.setState({ isLoading: false });
  }
};


export const checkMinMaxValue = ({ target }, component, min, max) => {
  let { value } = target;
  const { data } = component.state;
  value = value !== '' ? parseInt(value, 10) : 0;
  if (value < min) {
    target.value = min;
  }
  if (value > max) {
    target.value = max;
  }
  component.setState({
    data: { ...data, slotInterval: target.value }
  });
};
